import React from 'react';
import ClaimFieldsTable from './ClaimFieldsTable';
export default function LossMemoTable(_ref) {
  let {
    claim,
    setClaim,
    calculations,
    refreshCalculations
  } = _ref;
  const lossMemoRows = [{
    text: 'Losses brought forward',
    field_1: {
      name: 'loss_memo_losses_brought_forward',
      editable: true
    },
    field_2: {
      name: 'loss_memo_losses_brought_forward'
    }
  }, {
    text: 'Losses generated',
    field_1: {
      name: 'losses_generated_1'
    },
    field_2: {
      name: 'losses_generated_2'
    }
  }, {
    text: 'Losses utilised - CY profits',
    field_1: {
      name: 'loss_memo_losses_utilized_cy_profit',
      editable: true
    },
    field_2: {
      name: 'calculated_losses_utilized_cy_profits'
    }
  }, {
    text: 'Losses utilised - PY profits',
    field_1: {
      name: 'loss_memo_losses_utilized_py_profit',
      editable: true
    },
    field_2: {
      name: 'loss_memo_losses_utilized_py_profit',
      editable: true
    }
  }, {
    text: 'Losses utilised - surrendered for Group Relief',
    field_1: {
      name: 'loss_memo_losses_surrendered_for_group_relief_1',
      editable: true
    },
    field_2: {
      name: 'loss_memo_losses_surrendered_for_group_relief_2',
      editable: true
    }
  }, {
    text: 'Losses utilised - surrendered for R&D payable credit',
    field_1: {
      name: 'losses_utilized_surrendered_for_rnd_payable_credit_1'
    },
    field_2: {
      name: 'losses_utilized_surrendered_for_rnd_payable_credit_2'
    }
  }, {
    text: 'Losses carried forward',
    field_1: {
      name: 'losses_carried_forward_1'
    },
    field_2: {
      name: 'losses_carried_forward_2'
    }
  }, {
    text: 'Increase in Group Relief surrender',
    field: {
      name: 'increase_in_group_relief_surrender'
    }
  }, {
    className: 'font-weight-bold',
    text: 'BENEFIT - reduction in tax payable by Group company',
    field: {
      name: 'benefit_reduction_in_tax_payable_by_group_company'
    }
  }, {
    text: 'Increase in losses carried forward',
    field: {
      name: 'increase_in_losses_carried_forward'
    }
  }, {
    className: 'font-weight-bold',
    text: 'BENEFIT - value of increased losses carried forward',
    field: {
      name: 'benefit_value_of_increased_losses_carried_forward'
    }
  }];
  return /*#__PURE__*/React.createElement(ClaimFieldsTable, {
    calculations: calculations,
    refreshCalculations: refreshCalculations,
    claim: claim,
    setClaim: setClaim,
    title: "Loss memo",
    rows: lossMemoRows
  });
}